import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import * as D from '../../../deps';

const integrationData = {
  contentSection: D.Constants.ContentSections.BackstageContentSections.SIMILAR,
};

export const PodcastProgramRowGrid = props => {
  return (
    <D.Utils.Context.AppContextIntegrationData data={integrationData}>
      <D.ContentSection title={props.title} useDarkTheme={props.useDarkTheme}>
        <D.BackstageRowGrid>
          {props.elements.slice(0, 6).map(pandoraId => (
            <D.PodcastProgramRowItem
              id={pandoraId}
              key={pandoraId}
              isWidthHalf={true}
              hasBorderTopBottom={true}
              noHover={true}
              isClickableRow={true}
              showCollectedBadge={true}
              useLightTheme={props.useLightTheme}
              useDarkTheme={props.useDarkTheme}
            />
          ))}
        </D.BackstageRowGrid>
      </D.ContentSection>
    </D.Utils.Context.AppContextIntegrationData>
  );
};

PodcastProgramRowGrid.propTypes = {
  elements: ImmutablePropTypes.list.isRequired,
  title: PropTypes.node,
  useLightTheme: PropTypes.bool,
  useDarkTheme: PropTypes.bool,
};

export const PodcastProgramRowGridWithLogger = D.withVisibilityLogger(integrationData, {
  staticHeight: D.RowItemHeights.DEFAULT,
  useMemo: true,
})(PodcastProgramRowGrid);

export default PodcastProgramRowGrid;
